/**
 * Vite entry point. Mounts <App/> and imports global styles (which in turn
 * import the design tokens).
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource/figtree/400.css';
import '@fontsource/figtree/500.css';
import '@fontsource/figtree/700.css';
import '@fontsource/figtree/800.css';
import '@fontsource/jetbrains-mono/400.css';
import './styles/video-js.css';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  // WHY: index.html always provides #root; this guard keeps TS happy and fails
  // loudly if the entry template is ever broken.
  throw new Error('Root element #root not found.');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
